import {Component, effect, inject, resource, untracked} from '@angular/core';
import {CardComponent} from '../../../../../shared/components/card/card.component';
import {Router} from '@angular/router';
import {CardContentDirective} from '../../../../../shared/components/card/card-content.directive';
import {CartegraphManagementService} from '../../../../../data/cartegraph/cartegraph-management.service';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {FormBuilder, FormControl, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {CartegraphTaskActivitySettings} from '../../../../../shared/models/cartegraph.model';
import {RowWithToggleComponent} from '../../row-with-toggle/row-with-toggle.component';
import {MatButton} from '@angular/material/button';


@Component({
  selector: 'app-cartegraph-settings-observations',
  templateUrl: './cartegraph-task-activity-settings.component.html',
  styleUrls: ['../../../settings-fields.scss',
    '../../../settings-common.scss'],
  imports: [
    CardComponent,
    CardContentDirective,
    MatProgressSpinner,
    ReactiveFormsModule,
    RowWithToggleComponent,
    MatButton
  ],
  standalone: true
})
export class CartegraphTaskActivitySettingsComponent {

  private cartegraphManagementService = inject(CartegraphManagementService);
  private router = inject(Router);
  private fb = inject(FormBuilder);

  uiError: string;

  selectionsGroup = new FormGroup<{ [key: string]: FormControl<boolean | null> }>({});
  form = this.fb.group({
    selections: this.selectionsGroup,
  });

  private configResource = resource({
    loader: async () => (await this.cartegraphManagementService.getConfiguration()).data
  });

  activityResource = resource({
    loader: async () => (await this.cartegraphManagementService.getActivityList()).data
  });


  constructor() {

    effect(() => {
      const config = this.configResource.value();
      if (!config) {
        return;
      }
      const activities = this.activityResource.value();
      if (!activities) {
        return;
      }

      untracked(() => {
        activities.forEach(activity => {
          const disabled = config.settings.taskActivities?.disabledActivityId?.find(f => f === activity.oid) === undefined;
          this.selectionsGroup.addControl(activity.oid, new FormControl(disabled), {emitEvent: false});
        });

      });
    });

    // listen for changes on selections
    this.selectionsGroup.valueChanges.subscribe(values => {
      const mapping = Object.keys(values)
        .filter(i => values[i] !== undefined && values[i] !== null && values[i] === false)
        .map(key => {
          return key;
        });
      this.updateConfiguration(mapping);
    });

  }

  updateConfiguration(disabledOids: string[]) {
    const taskActivitySettings = this.configResource.value().settings.taskActivities ?? new CartegraphTaskActivitySettings();
    taskActivitySettings.disabledActivityId = disabledOids;
    this.cartegraphManagementService.updateTaskActivities(taskActivitySettings).then(response => {
      if (!!response.error) {
        this.uiError = response.error;
        console.error(response.error);
      } else {
        // this.configResource.reload(); // only if we want to reload the config
      }
    }).catch(error => {
      console.error(error);
      this.uiError = error;
    });
  }

  protected navigateBack() {
    this.router.navigate(['settings/cartegraph-settings/settings/features']).then();
  }

  protected toggleAll(enabled: boolean) {
    const activities = this.activityResource.value();
    if (!activities) {
      return;
    }
    // Create a single object patch for the FormGroup
    const patch: Record<string, boolean> = {};
    activities.forEach(activity => {
      patch[activity.oid] = enabled;
    });
    // set value, change detection will trigger then update in the server side
    this.selectionsGroup.setValue(patch);
  }
}
